<select class="form-control form-control-sm" [(ngModel)]="value" (ngModelChange)="onValueChange()">
    <option [value]="AssignmentPermissions.None">
        <span cvLocalizedText langSection="Assign_Tool" langKey="None">None</span>
    </option>
    <option [value]="AssignmentPermissions.Read">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Read">Read</span>
    </option>
    <option [value]="AssignmentPermissions.ReadTheirs">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Read_Theirs">Read with Recipient Access Level</span>
    </option>
    <option [value]="AssignmentPermissions.ReadGroup">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Read_Group">Read with Group Nav</span>
    </option>
    <option [value]="AssignmentPermissions.ReadControl">
        <span cvLocalizedText langSection="Assign_Tool" langKey="ReadControl">ReadControl</span>
    </option>
    <option [value]="AssignmentPermissions.Write">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Write">Write</span>
    </option>
    <option [value]="AssignmentPermissions.WriteTheirs">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Write_Theirs">Write with Recipient Access Level</span>
    </option>
    <option [value]="AssignmentPermissions.Template">
        <span cvLocalizedText langSection="Assign_Tool" langKey="Template">Template</span>
    </option>
</select>
